export default "__VITE_ASSET__bafadb91__"